(function () {
  var home = window.JOVSHome;
  if (!home || !home.runtimeReady || home.sectionsReady) return;

  home.toggleAwardsLogoSwiper = function () {
    if (!home.swiperAwardsLogoElement) return;
    if (home.swiperAwardsLogoMediaQuery.matches) {
      if (!home.swiperAwardsLogo) {
        home.swiperAwardsLogo = new Swiper(home.swiperAwardsLogoElement, {
          slidesPerView: 5.5,
          spaceBetween: 10,
          speed: 600,
          watchOverflow: true,
          breakpoints: {
            768: {
              slidesPerView: 6,
              spaceBetween: 12,
            },
          },
        });
      } else {
        home.swiperAwardsLogo.update();
      }
      return;
    }
    if (home.swiperAwardsLogo) {
      home.swiperAwardsLogo.destroy(true, true);
      home.swiperAwardsLogo = null;
    }
  };

  home.initAwardsLogoManager = function () {
    if (home.awardsLogoManagerInitialized) return;
    home.awardsLogoManagerInitialized = true;
    home.toggleAwardsLogoSwiper();
    home.bindMediaQueryChange(home.swiperAwardsLogoMediaQuery, home.toggleAwardsLogoSwiper);
  };

  home.toggleAddTextCardSwiper = function () {
    if (!home.swiperAddTextCardElement) return;
    if (home.swiperAddTextCardMediaQuery.matches) {
      if (!home.swiperAddTextCard) {
        home.swiperAddTextCard = new Swiper(home.swiperAddTextCardElement, {
          slidesPerView: 1.08,
          spaceBetween: 14,
          speed: 600,
          watchOverflow: true,
          navigation: {
            nextEl: home.swiperAddTextCardNextButton,
            prevEl: home.swiperAddTextCardPrevButton,
          },
          breakpoints: {
            396: {
              slidesPerView: 1.15,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 18,
            },
          },
          on: {
            init: function (swiper) {
              home.updateSwiperProgress(swiper, home.swiperAddTextCardProgressFill);
            },
            slideChange: function (swiper) {
              home.updateSwiperProgress(swiper, home.swiperAddTextCardProgressFill);
            },
            resize: function (swiper) {
              home.updateSwiperProgress(swiper, home.swiperAddTextCardProgressFill);
            },
          },
        });
      } else {
        home.swiperAddTextCard.update();
        home.updateSwiperProgress(home.swiperAddTextCard, home.swiperAddTextCardProgressFill);
      }
      return;
    }
    if (home.swiperAddTextCard) {
      home.swiperAddTextCard.destroy(true, true);
      home.swiperAddTextCard = null;
    }
  };

  home.initAddTextCardManager = function () {
    if (home.addTextCardManagerInitialized) return;
    home.addTextCardManagerInitialized = true;
    home.toggleAddTextCardSwiper();
    home.bindMediaQueryChange(home.swiperAddTextCardMediaQuery, home.toggleAddTextCardSwiper);
  };

  home.initProhibitSelectSwipers = function () {
    if (!home.prohibitSelectSection || (home.swiperProhibitSelect && home.swiperProhibitSelectThumb)) return;
    home.swiperProhibitSelectThumb = new Swiper(".swiper-prohibit-select-thumb", {
      spaceBetween: 30,
      allowTouchMove: false,
      simulateTouch: false,
      effect: "fade",
    });
    home.swiperProhibitSelect = new Swiper(".swiper-prohibit-select", {
      spaceBetween: 30,
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-prohibit-select-navigation .swiper-button-next",
        prevEl: ".swiper-prohibit-select-navigation .swiper-button-prev",
      },
      thumbs: {
        swiper: home.swiperProhibitSelectThumb,
      },
      on: {
        init: function (swiper) {
          home.updateProhibitSelectProgress(swiper);
        },
        slideChange: function (swiper) {
          home.updateProhibitSelectProgress(swiper);
        },
        resize: function (swiper) {
          home.updateProhibitSelectProgress(swiper);
        },
      },
    });

    var prohibitSelectImages = home.prohibitSelectSection.querySelectorAll(".swiper-prohibit-select .img-wrap img");
    var refreshProhibitSelectLayout = function () {
      if (!home.swiperProhibitSelect || !home.swiperProhibitSelectThumb) return;
      home.swiperProhibitSelect.update();
      home.swiperProhibitSelectThumb.update();
      home.updateProhibitSelectProgress(home.swiperProhibitSelect);
    };

    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(function () {
        refreshProhibitSelectLayout();
        window.requestAnimationFrame(refreshProhibitSelectLayout);
      });
    } else {
      setTimeout(refreshProhibitSelectLayout, 0);
    }

    setTimeout(refreshProhibitSelectLayout, 120);

    Array.prototype.forEach.call(prohibitSelectImages, function (image) {
      if (image.complete) return;
      image.addEventListener("load", refreshProhibitSelectLayout, { once: true });
    });

    window.addEventListener("load", refreshProhibitSelectLayout, { once: true });
    if (home.prohibitSelectNavigationBound) return;
    home.prohibitSelectNavigationBound = true;

    if (home.swiperProhibitSelectPrevButton) {
      home.swiperProhibitSelectPrevButton.addEventListener("click", function () {
        if (home.swiperProhibitSelect) home.swiperProhibitSelect.slidePrev();
      });
    }

    if (home.swiperProhibitSelectNextButton) {
      home.swiperProhibitSelectNextButton.addEventListener("click", function () {
        if (home.swiperProhibitSelect) home.swiperProhibitSelect.slideNext();
      });
    }
  };

  home.toggleShopByConcernSwiper = function () {
    if (!home.shopByConcernSection || !home.swiperShopByConcernElement) return;
    if (!home.swiperShopByConcernMediaQuery.matches) {
      if (!home.swiperShopByConcern) {
        home.swiperShopByConcern = new Swiper(".swiper-shop-by-concern", {
          spaceBetween: 12,
          slidesPerView: "auto",
          navigation: {
            nextEl: home.swiperShopByConcernNextButton,
            prevEl: home.swiperShopByConcernPrevButton,
          },
          on: {
            init: function (swiper) {
              home.updateShopByConcernProgress(swiper);
            },
            slideChange: function (swiper) {
              home.updateShopByConcernProgress(swiper);
            },
            resize: function (swiper) {
              home.updateShopByConcernProgress(swiper);
            },
          },
        });
      } else {
        home.swiperShopByConcern.update();
        home.updateShopByConcernProgress(home.swiperShopByConcern);
      }
      return;
    }
    if (home.swiperShopByConcern) {
      home.swiperShopByConcern.destroy(true, true);
      home.swiperShopByConcern = null;
    }
  };

  home.initShopByConcernSwiper = function () {
    if (home.shopByConcernManagerInitialized) return;
    home.shopByConcernManagerInitialized = true;
    home.toggleShopByConcernSwiper();
    home.bindMediaQueryChange(home.swiperShopByConcernMediaQuery, function () {
      home.toggleShopByConcernSwiper();
      if (!home.swiperShopByConcernProgressFill) return;
      if (home.swiperShopByConcernMediaQuery.matches) {
        home.swiperShopByConcernProgressFill.style.width = "";
      } else if (home.swiperShopByConcern) {
        home.updateShopByConcernProgress(home.swiperShopByConcern);
      }
    });
  };

  home.initUserEvaluationSwiper = function () {
    if (!home.userEvaluationSection || home.swiperUserEvaluation) return;
    home.swiperUserEvaluation = new Swiper(".swiper-user-evaluation", {
      spaceBetween: 14,
      slidesPerView: 1.08,
      watchOverflow: true,
      breakpoints: {
        396: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 36,
        },
        1600: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
      },
    });
  };

  home.initTrustedRecommendedSwiper = function () {
    if (!home.trustedRecommendedSection || home.swiperTrustedRecommended) return;
    home.swiperTrustedRecommended = new Swiper(".swiper-trusted-recommended", {
      spaceBetween: 14,
      slidesPerView: 2.1,
      height: 300,
      watchOverflow: true,
      preventClicks: false,
      preventClicksPropagation: false,
      touchStartPreventDefault: false,
      navigation: {
        nextEl: home.swiperTrustedRecommendedNextButton,
        prevEl: home.swiperTrustedRecommendedPrevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 18,
          height: 400,
          noSwiping: true,
          noSwipingSelector: "video, .video-wrap",
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
          height: 420,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 28,
          height: 460,
        },
      },
      on: {
        init: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperTrustedRecommendedProgressFill);
        },
        slideChange: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperTrustedRecommendedProgressFill);
        },
        resize: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperTrustedRecommendedProgressFill);
        },
      },
    });
  };

  home.keepOurMissionThumbInView = function (targetIndex) {
    if (!home.swiperOurMissionThumb) return;
    var slidesPerView = Number(home.swiperOurMissionThumb.params.slidesPerView) || 1;
    var visibleSlidesCount = Math.max(Math.floor(slidesPerView), 1);
    var maxStartIndex = Math.max(home.swiperOurMissionThumb.slides.length - visibleSlidesCount, 0);
    var currentStartIndex = home.swiperOurMissionThumb.activeIndex;
    var visibleEndIndex = currentStartIndex + visibleSlidesCount - 1;
    var nextStartIndex = currentStartIndex;
    if (targetIndex >= visibleEndIndex) {
      if (visibleSlidesCount > 1) {
        nextStartIndex = Math.min(targetIndex - visibleSlidesCount + 2, maxStartIndex);
      } else {
        nextStartIndex = Math.min(targetIndex, maxStartIndex);
      }
    } else if (targetIndex <= currentStartIndex) {
      if (visibleSlidesCount > 1) {
        nextStartIndex = Math.max(targetIndex - 1, 0);
      } else {
        nextStartIndex = Math.max(targetIndex, 0);
      }
    }
    if (nextStartIndex !== currentStartIndex) home.swiperOurMissionThumb.slideTo(nextStartIndex);
  };

  home.syncOurMissionThumbLayout = function () {
    if (!home.swiperOurMissionThumb || !home.swiperOurMission) return;
    var isMobile = home.isOurMissionMobileLayout();
    home.swiperOurMissionThumb.params.mousewheel.enabled = !isMobile;
    if (isMobile) {
      home.swiperOurMission.params.creativeEffect.prev.translate = [0, -16, 0];
      home.swiperOurMission.params.creativeEffect.prev.scale = 0.97;
      home.swiperOurMission.params.creativeEffect.prev.opacity = 0.24;
      home.swiperOurMission.params.creativeEffect.next.translate = [0, 16, 0];
      home.swiperOurMission.params.creativeEffect.next.scale = 0.97;
      home.swiperOurMission.params.creativeEffect.next.opacity = 0.24;
    } else {
      home.swiperOurMission.params.creativeEffect.prev.translate = [0, -30, 0];
      home.swiperOurMission.params.creativeEffect.prev.scale = 0.95;
      home.swiperOurMission.params.creativeEffect.prev.opacity = 0.4;
      home.swiperOurMission.params.creativeEffect.next.translate = [0, 30, 0];
      home.swiperOurMission.params.creativeEffect.next.scale = 0.95;
      home.swiperOurMission.params.creativeEffect.next.opacity = 0.4;
    }
    home.swiperOurMissionThumb.update();
    home.swiperOurMission.update();
    home.keepOurMissionThumbInView(home.swiperOurMission.activeIndex);
    home.updateOurMissionProgress(home.swiperOurMissionThumb);
  };

  home.syncOurMissionByThumb = function (swiper) {
    if (!home.swiperOurMission || typeof swiper.clickedIndex !== "number") return;
    home.swiperOurMission.slideTo(swiper.clickedIndex);
    home.keepOurMissionThumbInView(swiper.clickedIndex);
  };

  home.initOurMissionSwipers = function () {
    if (!home.ourMissionSection || (home.swiperOurMission && home.swiperOurMissionThumb)) return;
    if (home.swiperOurMissionNextButton && !home.swiperOurMissionNextButton.dataset.limitClickBound) {
      home.swiperOurMissionNextButton.dataset.limitClickBound = "true";
      home.swiperOurMissionNextButton.addEventListener("click", home.handleOurMissionNextButtonClick, true);
    }
    home.swiperOurMissionThumb = new Swiper(".swiper-our-mission-thumb", {
      slidesPerView: 3,
      direction: "vertical",
      spaceBetween: 12,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 3,
          direction: "vertical",
          spaceBetween: 12,
          mousewheel: {
            enabled: false,
            forceToAxis: true,
          },
        },
        993: {
          slidesPerView: 3,
          direction: "vertical",
          spaceBetween: 12,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        },
      },
      on: {
        init: function (swiper) {
          home.updateOurMissionProgress(swiper);
        },
        slideChange: function (swiper) {
          home.updateOurMissionProgress(swiper);
        },
        resize: function (swiper) {
          home.updateOurMissionProgress(swiper);
        },
      },
    });
    home.swiperOurMission = new Swiper(".swiper-our-mission", {
      spaceBetween: 12,
      slidesPerView: 1,
      effect: "creative",
      allowTouchMove: false,
      navigation: {
        nextEl: home.swiperOurMissionNextButton,
        prevEl: home.swiperOurMissionPrevButton,
      },
      thumbs: {
        swiper: home.swiperOurMissionThumb,
      },
      on: {
        init: function (swiper) {
          home.keepOurMissionThumbInView(swiper.activeIndex);
          home.updateOurMissionNextButtonState(swiper);
        },
        slideChange: function (swiper) {
          home.keepOurMissionThumbInView(swiper.activeIndex);
          home.updateOurMissionNextButtonState(swiper);
        },
      },
      creativeEffect: {
        limitProgress: 2,
        prev: {
          shadow: false,
          translate: [0, -30, 0],
          scale: 0.95,
          opacity: 0.4,
        },
        next: {
          shadow: false,
          translate: [0, 30, 0],
          scale: 0.95,
          opacity: 0.4,
        },
      },
    });
    home.swiperOurMissionThumb.on("click", home.syncOurMissionByThumb);
    home.swiperOurMissionThumb.on("tap", home.syncOurMissionByThumb);
    home.swiperOurMissionThumb.on("breakpoint", home.syncOurMissionThumbLayout);
    home.syncOurMissionThumbLayout();
  };

  home.initAddBlogSwiper = function () {
    if (!home.addBlogSection || home.swiperAddBlog) return;
    home.swiperAddBlog = new Swiper(".swiper-add-blog", {
      spaceBetween: 14,
      slidesPerView: 1.4,
      height: 240,
      watchOverflow: true,
      navigation: {
        nextEl: home.swiperAddBlogNextButton,
        prevEl: home.swiperAddBlogPrevButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 18,
          height: 390,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
          height: 420,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 28,
          height: 440,
        },
      },
      on: {
        init: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperAddBlogProgressFill);
        },
        slideChange: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperAddBlogProgressFill);
        },
        resize: function (swiper) {
          home.updateSwiperProgress(swiper, home.swiperAddBlogProgressFill);
        },
      },
    });
  };

  if (home.halfCardShowItems.length) {
    home.syncHalfCardShowActiveItem();
    home.halfCardShowItems.forEach(function (item) {
      item.addEventListener("click", function (event) {
        if (!home.halfCardShowMediaQuery.matches) return;
        var productLink = event.target.closest(".bottom-img-wrap");
        if (productLink && !item.classList.contains("is-active")) event.preventDefault();
        home.setHalfCardShowActiveItem(item);
      });
    });
  }

  home.initSwiperWhenVisible(home.awardsLogoSection, home.initAwardsLogoManager);
  home.initSwiperWhenVisible(home.addTextCardSection, home.initAddTextCardManager);
  home.initSwiperWhenVisible(home.prohibitSelectSection, home.initProhibitSelectSwipers);
  home.initSwiperWhenVisible(home.shopByConcernSection, home.initShopByConcernSwiper);
  home.initSwiperWhenVisible(home.userEvaluationSection, home.initUserEvaluationSwiper);
  home.initSwiperWhenVisible(home.trustedRecommendedSection, home.initTrustedRecommendedSwiper);
  home.initSwiperWhenVisible(home.ourMissionSection, home.initOurMissionSwipers);
  home.initSwiperWhenVisible(home.addBlogSection, home.initAddBlogSwiper);
  home.bindMediaQueryChange(home.halfCardShowMediaQuery, home.syncHalfCardShowActiveItem);
  home.sectionsReady = true;
})();
